import { MeshParser } from '@seddi/mesh';
import type { BufferGeometry, LoadingManager } from '@seddi/three';
import { create as createGeometry } from '../core/bufferGeometry';
import type { VertexDataDesc } from '../core/bufferTypes';
import { load as loadFile } from '../loaders/binaryAssetLoader';
import { adaptGeometry } from './meshAdapter';

/**
 * Load mesh.
 * @param url = Resource URL.
 * @param manager - Loading manager.
 */
export const load = async (url: string, manager: LoadingManager): Promise<BufferGeometry> => {
  const bytes = await loadFile(url, manager);
  const data = MeshParser.Parse(bytes);
  const geometryDesc: VertexDataDesc = adaptGeometry(data.geometry);
  const geometry = createGeometry(geometryDesc);
  return geometry;
};
